import {useEffect, useState} from 'react';

/**
 *  useIsMobile custom hook:
 *  Global hook to check window screen size, currently being used to show or hide Quick View on ProductGrid
 *
 */

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const windowReady = typeof window !== 'undefined';

    if (!windowReady) return;

    setIsMobile(window.matchMedia('(max-width: 640px)').matches);

    const mediaQuery = window.matchMedia('(max-width: 640px)');

    const handleMediaChange = () => setIsMobile(mediaQuery.matches);

    mediaQuery.addEventListener('change', handleMediaChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, []);

  return isMobile;
}
